import { Divider as MuiDivider } from "@mui/material";
import React from "react";
import { dividerStyles } from "./dividerStyles";

const Divider: React.FC = () => {
    return <MuiDivider sx={dividerStyles} />;
};

export default Divider;
